export default {
    fields: {
        name:     'Naam',
        email:    'E-mail adres',
        language: 'Taal',
        password: 'Wachtwoord',

        password_change: {
            change:           'Wijzig wachtwoord',
            current_password: 'Huidig wachtwoord',
            new_password:     'Nieuw wachtwoord',
            repeat_password:  'Herhaal wachtwoord',
        },

        languages: {
            select: 'Selecteer taal',
        },
    },

    admin: {
        roles: {
            title:  'Rollen & Rechten',
            empty:  'Er zijn geen rollen gevonden',
            add:    'Voeg rol toe',
            save:   'Opslaan',
            delete: 'Verwijder rol',
        },

        versions: {
            title:          'Versiebeheer',
            empty:          'Er zijn geen versies gevonden',
            add:            'Voeg versie toe',
            save:           'Opslaan',
            delete:         'Verwijder versie',
            'create-major': 'Major release',
            'create-minor': 'Minor release',
            'create-patch': 'Patch release',
        },

        modules: {
            application: {
                title:      'Applicatie',
                submodules: {
                    versions: 'Versiebeheer',
                },
            },
            conneqt:     {
                title:      'Conneqt',
                submodules: {
                    workflows:         'Workflows',
                    entity_references: 'Entity references',
                },
            },
            accounts:    {
                title:      'Accountbeheer',
                submodules: {
                    roles_permissions: 'Rollen & Rechten',
                },
            },
        },
    },
};
